import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const FaQqSection = () => {

    const isMobile = useMediaQuery("(min-width:600px)");

    const [expanded, setExpanded] = useState("panel1");

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleWindowStore = () => {
        const url = 'https://apps.microsoft.com/detail/9P8QKZ93ZC28?hl=en-us&gl=IN&ocid=pdpshare'
        window.open(url, '_blank', 'noreferrer');
    }

    const handlePlayStore = () => {
        const url = 'https://play.google.com/store/apps/details?id=com.classiolabs.vsmart'
        window.open(url, '_blank', 'noreferrer');
    }

    return (
        <React.Fragment>
            <div style={{ paddingLeft: isMobile ? '10rem' : '1rem', paddingRight: isMobile ? '10rem' : '1rem', paddingTop: isMobile ? '8rem' : '1rem', paddingBottom: isMobile ? '8rem' : '1rem', position: "relative", background: "#F8F8F8" }}>
                <Grid container spacing={2} sx={{ pl: 2, pr: 2 }}>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Typography variant="h4"
                            sx={{ mb: 2 }}
                            fontSize={'2.2rem'}
                            fontWeight={'bold'}
                        >
                            FAQ
                        </Typography>
                        <Typography
                            sx={{ mb: 2, color: "black" }}
                            fontSize={'1.3rem'}
                            fontWeight={'bold'}
                        >
                            Still have any questions?
                        </Typography>
                        <Typography sx={{ mb: 2, fontSize: "14px" }}>
                            If you have any doubts or queries, feel free to reach out to us by shooting
                        </Typography>
                        <Typography sx={{ mb: 2, fontSize: "14px" }}>
                            us an email at support@globalvsmart.com or by calling us at +91-9876543210.
                        </Typography>
                        <Typography sx={{ mt: 10, fontSize: "14px", mb: 2, color: "#000", fontWeight: "bold" }}>
                            Download ExamPrep App Now
                        </Typography>
                        <Box sx={{ display: isMobile ? "flex" : "block", justifyContent: "left", alignItems: "left" }}>
                            <img src="img/playstore.svg" onClick={handlePlayStore} alt="" style={{ margin: "5px" }} />
                            <img src="img/applestore.svg" alt="" style={{ margin: "5px" }} />
                            <img src="img/windowstore.svg" onClick={handleWindowStore} alt="" style={{ margin: "5px" }} />
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ height: isMobile ? "500px" : "", overflow: "auto" }}>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel1' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>What is V Smart Exam Prep Test Series?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    V Smart Exam Prep offers high-quality test series for CA Foundation, Inter, and Final students to help them assess their preparation before exams.

                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel2' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>How do I register for the test series?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    You can register online through our official website by selecting the desired test series and completing the payment process.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel3' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>What types of test series are available?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left", mb: 1 }}>
                                    We offer:

                                </Typography>
                                <ul>
                                    <li style={{ marginBottom: "5px" }}>Portionwise Tests
                                    </li>
                                    <li style={{ marginBottom: "5px" }}>
                                        Chapter-wise Tests
                                    </li>
                                    <li style={{ marginBottom: "5px" }}>Full Course Tests﻿</li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel4' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Are the test papers designed as per ICAI standards?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Yes, our test papers are prepared by expert faculty and closely follow ICAI’s latest exam pattern and difficulty level.
                                    Test Format & Evaluation
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel5' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>How will I receive the test papers?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Test papers will be available for download on your dashboard after successful registration as per scheduled dates.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel6' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>How do I submit my answers for evaluation?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    You need to write your answers on paper, scan them, and upload them to the portal within the given time frame.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel7' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Are these Test Series Flexible?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Yes we do offer customized test series as per students convenience and level of preparation.

                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel8' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>How long does it take to receive the checked answer sheets?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Our evaluators will check your answers within 6-8 working days and provide detailed feedback.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel9' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Will I get model answers and suggested solutions?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Yes, we provide suggested answers along with the checked papers to help you understand the correct approach.
                                    Fees & Payment

                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel10' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>What is the fee structure for the test series?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Fees vary depending on the type of test series. You can check the latest pricing on our website.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel11' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}> What payment methods are available?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    We accept UPI, net banking, credit/debit cards, and other online payment methods.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel12' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Is there any refund policy?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    No, once a test series is purchased, it is non-refundable.

                                    Technical & Support

                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel13' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}> What if I face issues while uploading my answer sheet?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    You can contact our support team via email or WhatsApp for technical assistance.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel14'} onChange={handleChange('panel14')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel14' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Can I access the test series on mobile?﻿</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Yes, our website is mobile-friendly, and you can download or upload test papers from your phone.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion sx={{
                            textAlign: "left",
                            marginBottom: "20px", padding: "10px", boxShadow: "none", borderRadius: "20px", borderTopLeftRadius: "20px !important", borderTopRightRadius: "20px !important", background: "#b9b9b92e", borderBottomRightRadius: "20px !important", borderBottomLeftRadius: "20px !important", '&:before': {
                                display: 'none !important', // removes the default border
                            },
                        }} expanded={expanded === 'panel15'} onChange={handleChange('panel15')}>
                            <AccordionSummary
                                expandIcon={expanded === 'panel15' ? <RemoveIcon sx={{ color: "black" }} fontSize="large" /> : <AddIcon sx={{ color: "black" }} fontSize="large" />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Typography variant="h5" fontWeight={"bold"} sx={{ textTransform: "initial" }}>Who do I contact for further queries?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    You can reach out to our support team via:

                                </Typography>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    Email: examprep@vsmartacademy.com

                                </Typography>
                                <Typography sx={{ fontSize: "14px", textAlign: "left" }}>
                                    WhatsApp: 9130039454/55

                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>

                </Grid>
            </div>
        </React.Fragment>
    )
};

export default FaQqSection;